declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';


import { DBOperation } from '../../../../../enums/enum';
import { ActorEducationInfoRequest, ActorEducationInfoController } from '../../../../../models/profileinfo/profileinfo.model';

import { HCPService } from '../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';

@Component({
  selector: 'ngbeducationinfo',
  templateUrl: './educationinfo.modal.html',
  styleUrls: ['./educationinfo.modal.scss']
})

export class NgbEducationInfoModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  @Input() ActorCode: number;
  @Input() CurrentActorEducationInfoControllerByCode: ActorEducationInfoController;

  CurrentActorEducationInfoRequest: ActorEducationInfoRequest;
  public ApiResData: ApiResponseModel;

  public isRequesting: boolean = false;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService) { }
  ngOnInit() {

    this.CurrentActorEducationInfoRequest = new ActorEducationInfoRequest();
    this.CurrentActorEducationInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorEducationInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

  }



  onSubmit() {

    this.StartRefreshing();
    this.CurrentActorEducationInfoRequest.ConditionalOperator = 1;
    this.hcpservice.SaveActorEducationInfo(this.CurrentActorEducationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {


          alertFunctions.AlertParam('Saved Successfully.....!');
          this.activeModal.close();

          this.stopRefreshing();




        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.stopRefreshing();
        }
      }
      );

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  //
  ///////////////////DetailGrid
  //Grid Vars start
  disREADONLY: boolean = false;

  ddbops: DBOperation;
  dcolumns: any[] = [
    {
      display: 'InstituteName',
      variable: 'InstituteName',
      filter: 'text',
    },
    {
      display: 'InstituteType',
      variable: 'InstituteType',
      filter: 'text'
    },
    {
      display: 'Location',
      variable: 'Location',
      filter: 'text'
    }
    ,
    {
      display: 'CourseStudy',
      variable: 'CourseStudy',
      filter: 'text'
    }
    ,
    {
      display: 'StartFrom',
      variable: 'StartFrom',
      filter: 'date'
    }
    ,
    {
      display: 'CompletedAt',
      variable: 'CompletedAt',
      filter: 'date'
    }
    ,
    {
      display: 'IsGraduate',
      variable: 'IsGraduate',
      filter: 'text'
    }
    ,
    {
      display: 'CourseType',
      variable: 'CourseType',
      filter: 'text'
    }
    ,
    {
      display: 'Subjects',
      variable: 'Subjects',
      filter: 'text'
    }
    ,
    {
      display: 'Remarks',
      variable: 'Remarks',
      filter: 'text'
    }


  ];




}
